export const TurnCountElement =  ()=>{
    return (
        <div className="container">
            ターンカウントはカードがその場所に来てから何ターン目かを調べるものです。（難しいので非推奨です）
            以下の例では１ターン目移行にその場所にカードが来たことを表しています
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_turn_count.png`}></img></p>
        </div>
    )
}
